export const formatValue = (
	input: number | string | any,
	unitType: 'consumption' | 'price' | 'general' = 'general',
	options: {
		minDecimals?: number
		maxDecimals?: number
		forceDecimals?: number
	} = {}
): string => {
	const { minDecimals = 0, maxDecimals = 3, forceDecimals } = options

	const value = Number(input ?? 0)

	if (isNaN(value)) return '0'

	let decimals = forceDecimals

	if (decimals === undefined) {
		const absValue = Math.abs(value)

		if (unitType === 'consumption' || unitType === 'price') {
			if (absValue < 0.1 && value !== 0) {
				decimals = 3
			} else if (absValue < 1) {
				decimals = 2
			} else if (absValue < 10) {
				decimals = 1
			} else {
				decimals = 0
			}
		} else {
			if (absValue < 0.1 && value !== 0) {
				decimals = 3
			} else if (absValue < 1) {
				decimals = 2
			} else {
				decimals = 1
			}
		}
	}

	decimals = Math.max(minDecimals, Math.min(maxDecimals, decimals))

	return value.toFixed(decimals).replace('.', ',')
}
